import {FormArray, FormControl, FormGroup} from '@angular/forms';
import { DescricaoAtributo } from '../functions/DescricaoAtributo';
import { AssuntoDTO } from './AssuntoDTO';
import { Classificacao } from './Classificacao';
import {ConciliadorMediadorRequerenteDTO} from "./relatorio/ConciliadorMediadorRequerenteDTO";
import {
  MonitoramentoConciliacaoRequest
} from '../view/manifestos/consulta/cartorios-extrajudicial-consulta/partials/monitoramento-conciliacao-form/monitoramento-conciliacao-form.dto';

@DescricaoAtributo({
  nome: 'Nome do Usuário',
  email: 'Email do Usuário',
  codigoCNS: 'CNS da serventia',
  nomeMunicipioServentia: 'Localidade',
  nomeServentia : 'Nome completo da serventia',
  nomeResponsavelServentia: 'Responsável pela serventia',
  tipoClassificacao: 'Sua demanda se refere a',
  descricaoConsulta: 'Descrição da Consulta',
  listaClassificacao: 'Assunto(s)',
  assunto: 'Assunto',
  dadosRequerente: 'Dados do conciliador/mediador requerente',
  listaConciliador: 'Dados do conciliador/mediador adicional',
  termoDeclaracaoVerdade: 'Declaração de veracidade das informações',
  monitoramentoConciliacao: 'Monitoramento das Atividades de Conciliação e Mediação',
})
export class ConsultaVO {
  id: number;
  username: FormControl | string = '';
  dataHoraAbertura: Date;
  nome: FormControl | string;
  email: FormControl | string;
  descricaoConsulta: FormControl | string;
  listaClassificacao: FormControl | Classificacao[];
  listaClassificacaoCompleta: Classificacao[];
  files: any[] = [];
  assunto: FormControl | AssuntoDTO;
  assuntos: AssuntoDTO[];
  codigoCNS :  FormControl | number ;
  codigoCNSFormatado :  FormControl | string = '';
  nomeMunicipioServentia : FormControl | string = '';
  nomeResponsavelServentia : FormControl | string = '';
  nomeServentia : FormControl | string = '';
  codigoMunicipioServentia : FormControl | number ;
  tipoClassificacao : FormControl | number;
  codigoComarca : FormControl | number ;
  demandaRecebida: FormControl | string = '';
  dadosRequerente: FormGroup | ConciliadorMediadorRequerenteDTO;
  listaConciliador: FormArray | ConciliadorMediadorRequerenteDTO;
  termoDeclaracaoVerdade: FormControl | string;
  monitoramentoConciliacao: FormControl | MonitoramentoConciliacaoRequest;
}
